/**
 * What an ask an agent puts to the person holds (docs/agent.md#asking-you), shared by the server, which keeps asks
 * (src/agent/questions.ts), and the runtime, whose `coast.respond` answers one from its page (src/client/data-host.ts).
 */
export const QUESTION_LIMITS = {
  /** A question's text, and an answer's. */
  textChars: 4_000,
  /** A page's answer's value, as JSON. */
  valueBytes: 16_384,
  /** An answer's label, what was chosen as the person would say it, and a choice's option. */
  labelChars: 200,
  /** The answered and withdrawn asks the list gives after the waiting ones. */
  settled: 20,
  /** The questions one ask holds. */
  questions: 10,
  /** The options of a choice, from 2. */
  options: 12,
  /** An ask's title, which its notification names. */
  titleChars: 80,
  /** A reference's caption, under its picture or its link. */
  captionChars: 300,
  /** What an ask or a question says to answer it well: why it matters, how others do it, what the asker recommends. */
  detailChars: 2_000,
  /** What one option of a choice means, under its label. */
  optionDetailChars: 400,
  /** A reference's live panel, its HTML with its styles and scripts, which a record of the ask's page keeps. */
  htmlBytes: 48_000,
};

/** An ask's id: `qst_` and 16 hex digits, as a session's is `ses_` and 16. */
export const QUESTION_ID = /^qst_[0-9a-f]{16}$/;

/** What a label that isn't one is told. */
export const LABEL_PROBLEM = `A label is plain text of 1 to ${QUESTION_LIMITS.labelChars} characters.`;

/**
 * The label `coast.respond(value, label)` gives with its value: plain text naming what was chosen, as the person would
 * say it ("Reject", "Saturday"), which shows as their answer's bubble. Its runs of spaces and lines become one space.
 * Undefined for none (absent or null), and null for one that isn't plain text of 1 to `labelChars` characters.
 */
export function labelOf(label: unknown): string | undefined | null {
  if (label === undefined || label === null) return undefined;
  if (typeof label !== "string") return null;
  const text = label.replace(/\s+/g, " ").trim();
  return text && text.length <= QUESTION_LIMITS.labelChars ? text : null;
}
